import React from 'react';
import PricingPlan from '../pricing';
import { motion } from 'framer-motion';
import {
  FreeCost,
  FreeTime,
  MonthTime,
  MonthCost,
  YearCost,
  YearTime,
} from '../../constants';
import { useTranslation } from 'react-i18next';
import { FaCrown } from 'react-icons/fa';

const SlideFour = () => {
  const { t } = useTranslation();

  const freeData = {
    type: t('pricing.freePlan.title'),
    cost: FreeCost,
    time: FreeTime,
    one: t('pricing.freePlan.features.textCourses'),
    two: t('pricing.freePlan.features.videoCourses'),
    three: t('pricing.freePlan.features.aiTokens'),
    four: t('pricing.freePlan.features.subTopics'),
    five: t('pricing.freePlan.features.basicCreation'),
    buttonText: t('pricing.freePlan.buttonText'),
    planId: 'free',
  };

  const monthData = {
    type: t('pricing.monthlyPlan.title'),
    cost: MonthCost,
    time: `/${MonthTime}`,
    popular: t('pricing.monthlyPlan.popular'),
    one: t('pricing.monthlyPlan.features.unlimitedText'),
    two: t('pricing.monthlyPlan.features.unlimitedVideo'),
    three: t('pricing.monthlyPlan.features.subTopics'),
    four: t('pricing.monthlyPlan.features.aiStoryteller'),
    five: t('pricing.monthlyPlan.features.prioritySupport'),
    six: t('pricing.monthlyPlan.features.betterResults'),
    seven: t('pricing.monthlyPlan.features.createAiStoryteller'),
    buttonText: t('pricing.monthlyPlan.buttonText'),
    planId: 'monthly',
  };

  const yearData = {
    type: t('pricing.yearlyPlan.title'),
    cost: YearCost,
    time: `/${YearTime}`,
    one: t('pricing.yearlyPlan.features.unlimitedText'),
    two: t('pricing.yearlyPlan.features.unlimitedVideo'),
    three: t('pricing.yearlyPlan.features.subTopics'),
    four: t('pricing.yearlyPlan.features.aiStoryteller'),
    five: t('pricing.yearlyPlan.features.prioritySupport'),
    six: t('pricing.yearlyPlan.features.betterResults'),
    seven: t('pricing.yearlyPlan.features.createAiStoryteller'),
    eight: t('pricing.yearlyPlan.freeMonths'),
    buttonText: t('pricing.yearlyPlan.buttonText'),
    planId: 'yearly',
  };

  return (
    <main className="w-full bg-white dark:bg-slate-950">
      <div className="relative overflow-hidden border-t border-slate-200 dark:border-slate-800">
        <div className="absolute inset-0 bg-gradient-to-b from-gray-50/50 via-white to-white dark:from-gray-950 dark:via-gray-950 dark:to-gray-950" />
        <div className="relative px-4 py-12 md:py-16 max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto mb-20"
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 mb-6">
              <FaCrown className="text-blue-600 dark:text-blue-400 text-sm" />
              <span className="text-xs font-semibold text-blue-700 dark:text-blue-300">
                {t('landing.slideFour.badge', 'Choose your learning journey')}
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white mb-6 tracking-tight">
              {t('landing.slideFour.title')}
            </h2>
            <p className="text-base sm:text-lg text-gray-600 dark:text-gray-400 font-light">
              {t('landing.slideFour.subtitle', 'Choose a plan that matches your learning pace')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="flex flex-col items-center"
            >
              <PricingPlan data={freeData} />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="flex flex-col items-center"
            >
              <PricingPlan data={monthData} />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3 }}
              className="flex flex-col items-center"
            >
              <PricingPlan data={yearData} />
            </motion.div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SlideFour;
